module.exports = __webpack_public_path__ + "static_pc/img/11.00ad2550.png";